import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#F1F4FA"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51M102.5 23a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M91.062 6.94a1.5 1.5 0 0 1 0 2.12l-10.001 10a1.5 1.5 0 1 1-2.122-2.12l10.001-10a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M78.94 6.94a1.5 1.5 0 0 1 2.12 0l10.002 10a1.5 1.5 0 1 1-2.122 2.12l-10-10a1.5 1.5 0 0 1 0-2.12"
      clipRule="evenodd"
    />
    <path fill="#ACB8C3" d="M51.5 105a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M21 45.5a1.5 1.5 0 0 1 1.5 1.5v13.999a1.5 1.5 0 0 1-3 0V47a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M12.5 54a1.5 1.5 0 0 1 1.5-1.5h14a1.5 1.5 0 0 1 0 3H14a1.5 1.5 0 0 1-1.5-1.5M28 103a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#ACB8C3"
      fillRule="evenodd"
      d="M78.71 93.167H14.545V69.834h26.25c5.326 0 9.819 3.57 11.217 8.446H36.805a1.609 1.609 0 1 0 0 3.217H52.46v.003h14.584c6.442 0 11.666 5.224 11.666 11.667"
      clipRule="evenodd"
    />
    <path
      fill="#7B8493"
      d="M14.543 95.228V67.772a3.772 3.772 0 0 0-7.543 0v27.456a3.772 3.772 0 0 0 7.543 0"
    />
    <path
      fill="#C7D0D9"
      d="M72 70c12.703 0 23-10.297 23-23S84.703 24 72 24 49 34.297 49 47s10.297 23 23 23"
    />
    <path
      fill="#7B8493"
      fillRule="evenodd"
      d="M72 33.982a2.25 2.25 0 0 1 2.25 2.25v10.231h9.304a2.25 2.25 0 1 1 0 4.5H72a2.25 2.25 0 0 1-2.25-2.25v-12.48a2.25 2.25 0 0 1 2.25-2.25"
      clipRule="evenodd"
    />
  </svg>
);
const SvgEnrichedIconSavingTimeGreyscale = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconSavingTimeGreyscale);
export default Memo;
